module.exports = __webpack_public_path__ + "img/head.39c7b2ae.png";